(() => {
  const initFade = (root = document) => {
    const els = root.querySelectorAll("[data-sa-fade]");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          const delay = parseInt(el.getAttribute("data-sa-delay") || "0", 10);
          if (delay > 0) {
            setTimeout(() => el.classList.add("is-visible"), delay);
          } else {
            el.classList.add("is-visible");
          }
          obs.unobserve(el);
        });
      },
      { threshold: 0.15 }
    );

    els.forEach((el) => obs.observe(el));
  };

  const initCounters = (root = document) => {
    const els = root.querySelectorAll("[data-sa-counter]");
    if (!els.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;

          if (el.getAttribute("data-sa-started") === "1") return;
          el.setAttribute("data-sa-started", "1");

          const target = parseInt(el.getAttribute("data-target") || "0", 10);
          const duration = parseInt(el.getAttribute("data-duration") || "1600", 10);
          const steps = parseInt(el.getAttribute("data-steps") || "40", 10);

          let current = 0;
          const inc = target / steps;
          const tick = duration / steps;

          const timer = setInterval(() => {
            current += inc;
            if (current >= target) {
              el.textContent = target.toLocaleString();
              clearInterval(timer);
            } else {
              el.textContent = Math.floor(current).toLocaleString();
            }
          }, tick);

          obs.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    els.forEach((el) => obs.observe(el));
  };

  const initAll = (root) => {
    initFade(root);
    initCounters(root);
  };

  const boot = () => initAll(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor reload対応
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();